import React from "react";
import PlayerAssetAddEditPage from "./PlayerAssetAddEditPage";
import { PLAYER_ASSET_TYPES } from "../../../constants/playerAssetTypes";

const PlayerBackgroundAddEditPage = () => <PlayerAssetAddEditPage config={PLAYER_ASSET_TYPES.background} />;

export default PlayerBackgroundAddEditPage;
